/**
 * External Imports
 */
import { FC, Dispatch, SetStateAction } from 'react';

/**
 * Internal Imports
 */
import FeedbackTable from '../../components/customTables/tasks/feedbackTable';
import SearchHeader from '../../components/searchHeader';

/**
 * Style Imports
 */
import { TaskContainer } from './styles/Employee.styles';

interface IEmployeeFeedbackProps {
  searchTerm: string;
  setSearchTerm: Dispatch<SetStateAction<string>>;
}

const EmployeeFeedback: FC<IEmployeeFeedbackProps> = ({
  searchTerm,
  setSearchTerm
}) => {
  return (
    <TaskContainer id="Employee-Feedback">
      <SearchHeader searchTerm={searchTerm} setSearchTerm={setSearchTerm} />
      <FeedbackTable searchTerm={searchTerm} />
    </TaskContainer>
  );
};

export default EmployeeFeedback;
